import { Controller } from '@hotwired/stimulus';
import "bootstrap";  // Ensure Bootstrap is imported

export default class extends Controller {
  connect() {
    $(this.element).tooltip();
  }

  disconnect() {
    $(this.element).tooltip('dispose')
  }
}